import React, { useEffect, useState } from 'react';
import SectionTitle from '../sectionTitle/SectionTitle';
import Slider from 'react-slick';
import RecommendedProducts from '../../components/blog/itemProp/RecommendedProducts';
import { get } from '../../utils/api_helper';
import SouthAsianMarkets from '../../components/blog/itemProp/SouthAsianMarkets';

const Products = () => {
  const [randomData, setRandomData] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [saleProducts, setSaleProducts] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [verifiedSupplierProducts, setVerifiedSupplierProducts] = useState([]);

  const [loadingRandom, setLoadingRandom] = useState(true);
  const [loadingFeatured, setLoadingFeatured] = useState(true);
  const [loadingSale, setLoadingSale] = useState(true);
  const [loadingVerified, setLoadingVerified] = useState(true);

  const loop = Array.from({ length: 12 }, (_, i) => i + 1);

  useEffect(() => {
    // Random Products
    get('/listings/random')
      .then((resp) => resp.status && setRandomData(resp.data))
      .catch((err) => console.error('error fetching random products', err))
      .finally(() => setLoadingRandom(false));

    // Featured Products
    get('/listings/featured')
      .then((resp) => resp.status && setFeaturedProducts(resp.data))
      .catch((err) => console.error('error fetching featured products', err))
      .finally(() => setLoadingFeatured(false));

    // Sale + New Arrivals
    get('/listings/saleProducts')
      .then((resp) => {
        if (resp.status) {
          setSaleProducts(resp.data?.saleProducts || []);
          setNewArrivals(resp.data?.newArrivals || []);
        }
      })
      .catch((err) => console.error('error fetching sale/new arrivals', err))
      .finally(() => setLoadingSale(false));

    // Verified Supplier Products
    get('/listings/getVerifiedProducts')
      .then((resp) => resp.status && setVerifiedSupplierProducts(resp.data?.verifiedListings))
      .catch((err) => console.error('error fetching verified products', err))
      .finally(() => setLoadingVerified(false));
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true },
      },
      { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const markets = [
    { id: 'afghanistan', name: 'Afghanistan', image: '/images/country-images/afghanistan.webp', flag: '/images/country-flags/af.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'bangladesh', name: 'Bangladesh', image: '/images/country-images/bangladesh.webp', flag: '/images/country-flags/bd.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'bhutan', name: 'Bhutan', image: '/images/country-images/bhutan.webp', flag: '/images/country-flags/bh.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'india', name: 'India', image: '/images/country-images/india.webp', flag: '/images/country-flags/in.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'nepal', name: 'Nepal', image: '/images/country-images/nepal.webp', flag: '/images/country-flags/ne.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'maldives', name: 'Maldives', image: '/images/country-images/maldives.webp', flag: '/images/country-flags/mv.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'pakistan', name: 'Pakistan', image: '/images/country-images/pakistan.webp', flag: '/images/country-flags/pk.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
    { id: 'sri-lanka', name: 'Sri Lanka', image: '/images/country-images/srilanka.webp', flag: '/images/country-flags/lk.png', description: 'Verified Products & Sellers\nBuyers and Suppliers\nTrade Resources' },
  ];

  return (
    <div className="blog-area mb--30">
      <div className="container">
        {/* South Asian Markets */}
        <div className="row">
          <div className="col-lg-12 pt--30">
            <SectionTitle titleLine="title-line" radiusRounded="" title="South Asian Markets" />
            <Slider {...settings}>
              {markets.map((market) => (
                <div key={market.id} className="col-12">
                  <SouthAsianMarkets StyleVar="box-card-style-default" data={market} />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* Featured Products */}
        <div className="row">
          <div className="col-lg-12 pt--30">
            <SectionTitle titleLine="title-line" radiusRounded="" title="Featured Products" />
            {loadingFeatured ? (
              <div className="spinner-custom">{loop.map((x) => <span key={x} className="sr-only-custom" />)}</div>
            ) : (
              <Slider {...settings}>
                {featuredProducts.map((item) => (
                  <div key={item.id} className="col-12">
                    <RecommendedProducts StyleVar="box-card-style-default" data={item} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>

        {/* Recommended Products */}
        <div className="row">
          <div className="col-lg-12 pt--30">
            <SectionTitle title="Recommended Products" titleLine="title-line" />
            {loadingRandom ? (
              <div className="spinner-custom">{loop.map((x) => <span key={x} className="sr-only-custom" />)}</div>
            ) : (
              <Slider {...settings}>
                {randomData.filter((item) => !item.featured).map((item) => (
                  <div key={item.id} className="col-12">
                    <RecommendedProducts StyleVar="box-card-style-default" data={item} />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>

        {/* Sale Products */}
        {saleProducts.length > 4 && (
          <div className="row">
            <div className="col-lg-12 pt--30">
              <SectionTitle titleLine="title-line" radiusRounded="" title="Hot Sale" />
              {loadingSale ? (
                <div className="spinner-custom">{loop.map((x) => <span key={x} className="sr-only-custom" />)}</div>
              ) : (
                <Slider {...settings}>
                  {saleProducts.map((item) => (
                    <div key={item.id} className="col-12">
                      <RecommendedProducts StyleVar="box-card-style-default" data={item} />
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        )}

        {/* Verified Suppliers */}
        {verifiedSupplierProducts.length > 4 && (
          <div className="row">
            <div className="col-lg-12 pt--30">
              <SectionTitle titleLine="title-line" radiusRounded="" title="Verified Suppliers" />
              {loadingVerified ? (
                <div className="spinner-custom">{loop.map((x) => <span key={x} className="sr-only-custom" />)}</div>
              ) : (
                <Slider {...settings}>
                  {verifiedSupplierProducts.map((item) => (
                    <div key={item.id} className="col-12">
                      <RecommendedProducts StyleVar="box-card-style-default" data={item} />
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        )}

        {/* New Arrivals */}
        {newArrivals.length > 4 && (
          <div className="row">
            <div className="col-lg-12 pt--30">
              <SectionTitle titleLine="title-line" radiusRounded="" title="New Arrivals" />
              {loadingSale ? ( // reusing sale loader since it's same request
                <div className="spinner-custom">{loop.map((x) => <span key={x} className="sr-only-custom" />)}</div>
              ) : (
                <Slider {...settings}>
                  {newArrivals.map((item) => (
                    <div key={item.id} className="col-12">
                      <RecommendedProducts StyleVar="box-card-style-default" data={item} />
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
